<template>
    <div class="inner-page news-list-page">
      <app-layout ovflowFlowMain="auto">
        <app-header slot="header">
          <header-right slot="right"></header-right>
        </app-header>
        <a-spin size="large" :spinning="isLoading">
          <div class="inner-page__main" slot="default">
            <div class="inner-page__main__bg news-list--bg">
              <breadcrumb :navList="false"></breadcrumb>
              <div class="inner-page__content">
                
                <div class="news-list-wrap">
                  <div class="news-list-wrap__left">
                    <div class="inner-page__content--header">
                        <div class="inner-page__content--title">
                          <span class="title">时政新闻</span>
                        </div>
                    </div>
                    <div class="news-wrap" v-if="newsList.length">
                      <div class="news-list">
                        <div class="item" v-for="(item, index) in newsList" :key="index">
                          <div class="item-img" @click="goTo('/newDetail', item.id)" v-if="item.image">
                            <img :src="`${item.image}`">
                          </div>
                          <div class="item-text">
                            <h6 class="title" @click="goTo('/newDetail', item.id)">{{item.title}}</h6>
                            <div class="abstract">{{item.desc}}</div>
                            <div class="time">{{item.created}}</div>
                          </div>
                        </div>
                      </div>
                      <pagination :total="total" @pageChange="onPageChange" @pageSizeChange="onPageSizeChange"></pagination>
                    </div>
                    <empty v-else />
                  </div>
                  <div class="news-list-wrap__right">
                    <div class="inner-page__content--header">
                        <div class="inner-page__content--title">
                          <span class="title">热门推荐</span>
                        </div>
                    </div>
                    <div class="popular-recommend" v-if="popularRecommend.length">
                      <div class="item" v-for="(item, index) in popularRecommend" :key="index">
                        <h6 class="title" @click="goTo('/newDetail', item.id)">{{item.title}}</h6>
                        <p class="time">{{item.created}}</p>
                      </div>
                    </div>
                    <empty v-else />
                  </div>
                </div>
                
              </div>
			  <breadcrumb :navList="navList"></breadcrumb>
            </div>
          </div>
        </a-spin>
      </app-layout>
    </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import Breadcrumb from '../components/breadcrumb/breadcrumb.vue'
import Empty from '../components/empty/empty.vue'
import Pagination from '../components/pagination/pagination.vue'
import { news } from '@/api'

export default {
  name: 'newsList',
  components: { HeaderRight, Breadcrumb, Empty, Pagination },
  data () {
    return {
      navList: [
        {
          text: '返回首页'
        },
        {
          text: '时政新闻'
        }
      ],
      newsList: [],
      popularRecommend: [],
      total: 100,
      pageSize: 10,
      isLoading: true
    }
  },
  created () {
    Promise.all([this.getNewsList(), this.getPopularRecommend()]).then(() => {
    }).catch(() => {
      this.$message.error('请求数据失败')
    }).finally(() => {
      this.isLoading = false
    })
  },
  methods: {
    onPageChange ({pageNumber}) {
      // console.log(pageNumber)
      let params = {
        page: pageNumber,
        pageSize: this.pageSize
      }
      this.getNewsList(params)
    },

    onPageSizeChange ({current, pageSize}) {
      let params = {
        page: current,
        pageSize: pageSize
      }
      this.pageSize = pageSize
      this.getNewsList(params)
    },

    getNewsList (params) {
      let temp = {
        page: 1,
        pageSize: this.pageSize,
        ...params
      }

      return news.list(temp).then(res => {
        let { data: { data = [], total }, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.newsList = data
        this.total = total
        return data
      })
    },

    goTo (path, id) {
      this.$router.push({path, query: { id }})
    },

    getPopularRecommend () {
      return news.hotNewsList().then(res => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.popularRecommend = data
        return data
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/style/index";
  .inner-page__content{
	  background-color: @contentBgColor;
  }
  .inner-page__content--title .title{
	  color: @titleColor;
  }
  .news-list--bg{
    min-height: 874px;
  }
  .news-list-page .inner-page__content{
    padding: 55px 20px;
  }
  .news-list-wrap{
    display: flex;
    justify-content: space-between;
    &__left{
      width: 985px;
      .news-list{
        padding: 15px 0 36px 0;
        .item{
          display: flex;
          justify-content: space-between;
          padding: 22px 30px;
          border-bottom: 1px solid rgba(216, 216, 216, 0.1); /*no*/
          &:hover{
            background-color: @titleBgColor;
            border-radius: 6px;
            // border-bottom-color: transparent;
            .item-img{
              cursor: pointer;
            }
            .item-text{
              .title{
                color: @hoverColor;
                text-decoration: underline;
                cursor: pointer;
              }
              .abstract{
                color: @textColor;
              }
            }
          }
          &-img{
            margin-right: 30px;
            img{
              width: 215px;
              height: 144px;
              border-radius: 10px;
            }
          }
          &-text{
            width: 687px;
            flex: 1;
            .title{
              font-size: 18px;
              color: @titleColor;
              margin: 0;
              .text-over();
            }
            .abstract{
              margin-top: 7px;
              color: @dateColor;
              font-size: 14px;
              .multiline-text-over(2);
            }
            .time{
              font-size: 12px;
              color: @dateColor;
              margin-top: 45px;
            }
          }
        }
      }
    }
    &__right{
      width: 375px;
      .popular-recommend{
        padding: 10px 0 36px 0;
        .item{
          padding: 15px 0;
          border-bottom: 1px solid rgba(216, 216, 216, 0.1); /*no*/
          .title{
            margin: 0;
            font-size: 14px;
            color: @textColor;
            .multiline-text-over(2);
            &:hover{
              color: @hoverColor;
              cursor: pointer;
              text-decoration: underline;
            }
          }
          .time{
            font-size: 12px;
            color: @dateColor;
            margin: 12px 0 0 0;
          }
        }
      }
    }
  }
</style>
